
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11194",
                "data-name": "矩形 11194",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0 0.064)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_235",
        "data-name": "蒙版组 235",
        "class": "cls-2",
        "transform": "translate(0 -0.064)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "组_8142",
            "data-name": "组 8142",
            "transform": "translate(3 2.064)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7742",
                "data-name": "路径 7742",
                "class": "cls-3",
                "d": "M85.362,74.316A8.634,8.634,0,1,1,94,65.682,8.58,8.58,0,0,1,85.362,74.316Zm0-16.034a7.4,7.4,0,1,0,7.4,7.4A7.422,7.422,0,0,0,85.362,58.282Zm-8.88.37a.453.453,0,0,1-.37-.123.966.966,0,0,1-.123-.987,12.881,12.881,0,0,1,3.453-2.837.818.818,0,0,1,.863.247.666.666,0,0,1-.247.987,10.09,10.09,0,0,0-3.083,2.467A.641.641,0,0,1,76.482,58.652Zm17.76,0a.935.935,0,0,1-.493-.247,11.814,11.814,0,0,0-3.083-2.467.635.635,0,1,1,.617-1.11,10.922,10.922,0,0,1,3.453,2.837.528.528,0,0,1-.123.863C94.489,58.529,94.366,58.652,94.242,58.652Z",
                "transform": "translate(-75.908 -54.657)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7743",
                "data-name": "路径 7743",
                "class": "cls-3",
                "d": "M459.428,453.122h-3.083v-3.083a.617.617,0,1,0-1.233,0v3.7a.583.583,0,0,0,.617.617h3.7a.617.617,0,0,0,0-1.233Z",
                "transform": "translate(-446.89 -440.864)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  